import React from 'react';

const Innskytingsskive: React.FC = () => {
  const renderBullseyeTarget = () => (
    <svg
      width="500"
      height="500"
      viewBox="0 0 550 550"
      style={{
        backgroundColor: 'white',
        marginRight: '40px',
      }}
    >
      <circle
        cx="275"
        cy="275"
        r="270"
        fill="none"
        stroke="#000"
        strokeWidth="4"
      />
      <circle
        cx="275"
        cy="275"
        r="215"
        fill="none"
        stroke="#000"
        strokeWidth="3"
      />
      <circle
        cx="275"
        cy="275"
        r="160"
        fill="none"
        stroke="#000"
        strokeWidth="3"
      />
      <circle
        cx="275"
        cy="275"
        r="105"
        fill="none"
        stroke="#000"
        strokeWidth="3"
      />
      <circle
        cx="275"
        cy="275"
        r="50"
        fill="none"
        stroke="#000"
        strokeWidth="3"
      />
      <line
        x1="5"
        y1="275"
        x2="545"
        y2="275"
        stroke="#4169E1"
        strokeWidth="2"
      />
      <line
        x1="275"
        y1="5"
        x2="275"
        y2="545"
        stroke="#4169E1"
        strokeWidth="2"
      />
      <circle cx="225" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="225"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        10
      </text>
      <circle cx="170" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="170"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        9
      </text>
      <circle cx="115" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="115"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        8
      </text>
      <circle cx="60" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="60"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        6
      </text>
      <circle cx="10" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="10"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        4
      </text>
      <circle cx="325" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="325"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        10
      </text>
      <circle cx="380" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="380"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        9
      </text>
      <circle cx="435" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="435"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        8
      </text>
      <circle cx="490" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="490"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        6
      </text>
      <circle cx="540" cy="275" r="8" fill="white" stroke="none" />
      <text
        x="540"
        y="279"
        fill="#666666"
        fontSize="10"
        fontWeight="bold"
        textAnchor="middle"
      >
        4
      </text>
    </svg>
  );

  const renderFormFields = () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '200px' }}>
      <div>
        <span style={{ color: '#4169E1', fontSize: '19px', fontWeight: 'bold' }}>Skive:</span>
        <div
          style={{
            borderBottom: '2px solid #000',
            width: '175px',
            height: '22px',
            marginTop: '8px',
          }}
        />
      </div>

      <div style={{ marginTop: '3px' }}>
        {[1, 2, 3, 4, 5, 6].map((num) => (
          <div key={num} style={{ marginBottom: '2px', display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#4169E1', fontSize: '19px', fontWeight: 'bold', marginRight: '10px', minWidth: '15px' }}>
              {num}:
            </span>
            <div
              style={{
                borderBottom: '2px solid #000',
                width: '144px',
                height: '22px',
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );

  const renderTargetSection = () => (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        marginBottom: '12.5mm',
        width: '100%',
        paddingLeft: '8px',
      }}
    >
      {renderBullseyeTarget()}
      {renderFormFields()}
    </div>
  );

  return (
    <div className="App">
      <div
        style={{
          backgroundColor: 'white',
          color: 'black',
          width: '210mm',
          minHeight: '297mm',
          margin: '0 auto',
          padding: '10mm 2mm 2mm 2mm',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          border: '1px solid #000',
        }}
      >
        {renderTargetSection()}
        
        {renderTargetSection()}
      </div>
      
      <style>
        {`
          @media print {
            .navigation {
              display: none !important;
            }
            
            @page {
              size: A4;
              margin: 0;
            }
            
            body {
              margin: 0;
              padding: 0;
            }
            
            * {
              -webkit-print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Innskytingsskive;
